import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { DEFAULT_WORK_TIME } from '../constants/time';
import { ERequestStatus } from '../types/request';
import { mapWorkTime } from '../utils/workTime';
export var useWorkTime = function useWorkTime(_ref) {
  var onRequestWorkTime = _ref.onRequestWorkTime,
      open = _ref.open;

  var _React$useState = React.useState(DEFAULT_WORK_TIME),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      workTime = _React$useState2[0],
      setWorkTime = _React$useState2[1];

  var _React$useState3 = React.useState(ERequestStatus.Initial),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      status = _React$useState4[0],
      setStatus = _React$useState4[1];

  var requestWorkTime = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setStatus(ERequestStatus.Loading);
            _context.next = 4;
            return onRequestWorkTime();

          case 4:
            result = _context.sent;
            setWorkTime(mapWorkTime(result));
            setStatus(ERequestStatus.Success);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            setStatus(ERequestStatus.Failure);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  })), [onRequestWorkTime]);
  React.useEffect(function () {
    if (open && status !== ERequestStatus.Success) {
      requestWorkTime();
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    requestWorkTime: requestWorkTime,
    status: status,
    workTime: workTime
  };
};